module.exports = __webpack_public_path__ + "static/img/game-logo-mg.bbffd31.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-mg.png
// module id = EK8H
// module chunks = 0 1 2 3 4 5 6